export const mutations = {
  SET_LIFFID (state, payload) {
    state.liffId = payload
  },
  SET_LIFF_READY (state, payload) {
    state.liffReady = payload
  },
  SET_LIFF_PROFILE (state, payload) {
    state.liffProfile = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/line/mutations.js